import { Button, Card, Row, Col, Tag, Space } from "antd";
import { FC, ReactNode } from "react";

type Props = {};

export const PerformancePayroll: FC<Props> = () => {
  return (
    <Card title="Performance & Payroll">
      <Card
        type="inner"
        title="February 2023"
        extra={<span>Job Hours: 520</span>}
      >
        <Row gutter={16}>
          <Col span={8}>
            <Statistic title="Avg. Efficiency" value={95} suffix="%" />
          </Col>
          <Col span={8}>
            <Statistic title="On-Time Rate" value={98} suffix="%" />
          </Col>
          <Col span={8}>
            <Statistic title="Client Rating" value={4.8} suffix="/5" />
          </Col>
        </Row>
      </Card>
      <Card
        type="inner"
        title="Payroll Status"
        extra={<Tag color="green">Current</Tag>}
        style={{ marginTop: 16 }}
      >
        <Row gutter={16}>
          <Col span={8}>
            <Statistic title="Next Processing" value="Mar 15, 2023" />
          </Col>
          <Col span={8}>
            <Statistic title="Pay Period" value="Mar 1-15" />
          </Col>
          <Col span={8}>
            <Statistic title="Pending Hours" value={168} />
          </Col>
        </Row>
      </Card>
      <Space
        style={{
          marginTop: 16,
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <Button>View Reports</Button>
        <Button>Process Payroll</Button>
      </Space>
    </Card>
  );
};

const Statistic = ({
  title,
  value,
  suffix,
}: {
  title: ReactNode;
  value: ReactNode;
  suffix?: ReactNode;
}) => {
  return (
    <div className="text-sm">
      <div className="text-gray-500">{title}</div>
      <div>
        {value}
        {suffix}
      </div>
    </div>
  );
};
